/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-11-11 16:55:03
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-17 15:04:43
 */
/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-31 16:06:43
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-01 09:38:27
 */
/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:55:36
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-08 16:15:38
 */
import req from "@/utils/request";

// 变量分组列表
export const add = (params) => req.post("/site-service/m/site/linksGroup/add", params);
export const list = (params) => req.post("/interact-service/m/isQuestionClassification/findList", params);
export const update = (params) => req.post("/site-service/m/site/linksGroup/update", params);
export const del = (params) => req.post("/site-service/m/site/linksGroup/del", params);
export const addLinks = (params) => req.post("/site-service/m/site/links/add", params);
export const listLinks = (params) => req.post("/interact-service/m/isQuestionAnswer/findListPage", params);
export const updateLink = (params) => req.post("/site-service/m/site/links/update", params);
export const delLink = (params) => req.post("/interact-service/m/isQuestionAnswer/deleteQuestionAnswer", params);
export const delBatch = (params) => req.post("/site-service/m/site/links/delBatch", params);
export const saveQuestionAnswer = (params) => req.post("/interact-service/m/isQuestionAnswer/saveQuestionAnswer", params);
export const editDel = (params) => req.post("/interact-service/m/isQuestionAnswer/byId", params);
export const saveQuestionClassification = (params) => req.post("/interact-service/m/isQuestionClassification/saveQuestionClassification", params);
export const updateQuestionClassification = (params) => req.post("/interact-service/m/isQuestionClassification/updateQuestionClassification", params);
export const deleteQuestionClassification = (params) => req.post("/interact-service/m/isQuestionClassification/deleteQuestionClassification", params);
export const updateQuestionAnswer = (params) => req.post("/interact-service/m/isQuestionAnswer/updateQuestionAnswer", params);
export const deleteQuestionAnswerIds = (params) => req.post("/interact-service/m/isQuestionAnswer/deleteQuestionAnswerIds", params);

